import { Box } from "@mui/material";
import Image from "next/image";
import { useTranslation } from "next-i18next";

import { Page, Section } from "@larvitu/shared/mui/ui-components";

import stockDoc4 from "../../../public/assets/images/AdobeStock_238730671.jpg";
import { ContactUs, FAQS, ServiceComponent } from "../../components";
import { getLayout } from "../../lib/getLayout";
import { getServerTranslations } from "../../lib/i18n/getServerTranslations";

import type { AppPage } from "../../@types/page";
import type { GetStaticProps, InferGetStaticPropsType } from "next";

// actual servicepage
const Services: AppPage<InferGetStaticPropsType<typeof getStaticProps>> = () => {
  const { t } = useTranslation(["service", "common", "faq", "contact"]);

  return (
    <Page title="Services">
      <Image
        src={stockDoc4}
        alt="Besprechung"
        placeholder="blur"
        priority
        style={{
          width: "100%",
          height: "auto",
        }}
      />

      <ServiceComponent
        header={t("header", { ns: "service" })}
        content={t("content", { ns: "service" })}
        serviceItems={t("serviceItems", { ns: "service", returnObjects: true })}
        contactButton={t("to-the-contact-form", { ns: "common" })}
      />

      <Section id="contactUs">
        <ContactUs
          header={t("arrival", { ns: "contact" })}
          openingHours={t("opening-hours", {
            ns: "contact",
            returnObjects: true,
          })}
          address={t("address", { ns: "contact", returnObjects: true })}
          content={t("content", { ns: "contact", returnObjects: true })}
        />

        <FAQS
          items={t("items", {
            ns: "faq",
            returnObjects: true,
          })}
        />
      </Section>
    </Page>
  );
};

Services.getLayout = getLayout;

export const getStaticProps: GetStaticProps = async ({ locale = "" }) => ({
  props: {
    ...(await getServerTranslations(locale, ["service", "common", "faq", "contact"])),
  },
});

export default Services;
